import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TopNavComponent } from '../../../../shared/containers/top-nav/top-nav.component';
import { MiniApps } from '../../../../shared/models';
import { AnalysisModuleStore } from '../../store';

@Component({
  selector: 'gnx-analysis-tool',
  templateUrl: './analysis-tool.component.html',
  styleUrls: ['./analysis-tool.component.scss'],
  imports: [TopNavComponent, RouterOutlet],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AnalysisToolComponent implements OnInit, OnDestroy {
  MiniApps = MiniApps;

  private analysisModuleStore = inject(AnalysisModuleStore);

  ngOnInit() {
    this.analysisModuleStore.loadCustomStatusOptions();
  }

  ngOnDestroy() {}
}
